<script setup>
import PaymentsComponent from "@/Components/Payments/PaymentsComponent.vue";
import {Permissions} from "@/Utils/Permissions";
</script>

<template>
  <v-container fluid style="min-height: 100vh;">
    <v-row v-if="Permissions.checkPermissions(['payments.list'])">
      <v-col cols="12">
        <PaymentsComponent/>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6">
        <!--    <NotesComponent/>-->
      </v-col>
    </v-row>
  </v-container>
</template>

<style scoped>

</style>